import {
  Card,
  CardFooter,
  PatientInner,
  PatientLayoutWrapper,
  UnAuthGraphics,
} from '../../components/common';
import { useCommonTranslation } from '../../hooks/i18n/useCommonTranslation';
import { useSite } from 'context/SiteContext';
import { useAuth } from '../../context/AuthContext';
import { useClientRect } from '../../hooks/getBoundingClientRect';
import { PageHelmet } from '../../components/common/PageHelmet';
import { FormTitle } from '../../components/common/Forms/Forms.styled';
import { FormDesc } from '../patient/AddHospital/AddHospitalForm.styled';
import { CommonButton } from '../../components/common/Forms/Button';
import { SiteSelectList } from '../../components/views-components/un-auth/SiteSelect/SiteSelectList';
import { useMemo } from 'react';
import { TopBannersLayout } from '../common/layout/TopBannersLayout';

export const ExpiredSiteStaff = () => {
  const { t } = useCommonTranslation();
  const { sangixUser } = useAuth();
  const { activeSite, setActiveSiteById } = useSite();
  const availableSites = useMemo(
    () =>
      sangixUser?.roles
        .filter((role) => role.site_id !== activeSite.id)
        .map((role) => {
          return {
            id: role.site_id,
            name: role.site_name,
          };
        }),
    [sangixUser, activeSite],
  );
  const { logout } = useAuth();
  const { rect, ref } = useClientRect();

  return (
    <TopBannersLayout>
      <PatientLayoutWrapper>
        {ref.current && <UnAuthGraphics contentRect={rect} />}
        <PatientInner ref={ref}>
          <PageHelmet title={t('site-expired')} />
          <Card>
            <FormTitle>{t('site-expired')}</FormTitle>
            {availableSites?.length && availableSites.length > 0 ? (
              <>
                <FormDesc
                  style={{
                    fontSize: 'var(--h4)',
                  }}
                >
                  {t('patient-site-expired-staff-description', {
                    site: activeSite.name,
                  })}
                </FormDesc>
                <SiteSelectList
                  onSiteSelect={(site) => setActiveSiteById(site.id)}
                  suggestions={availableSites}
                />
              </>
            ) : (
              <FormDesc
                style={{
                  fontSize: 'var(--h4)',
                }}
              >
                {t('patient-site-expired-staff-no-available-site-description', {
                  site: activeSite.name,
                })}
              </FormDesc>
            )}

            <CardFooter>
              <CommonButton variant="secondary" onClick={logout}>
                {t('logout')}
              </CommonButton>
            </CardFooter>
          </Card>
        </PatientInner>
      </PatientLayoutWrapper>
    </TopBannersLayout>
  );
};
